"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileDownloadItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _FileDownloadItem = require("./FileDownloadItem.styles");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");
var _button = require("../button");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var FileDownloadItem = function FileDownloadItem(_ref) {
  var title = _ref.title,
    attributes = _ref.attributes,
    onDownloadButtonClick = _ref.onDownloadButtonClick,
    _ref$isCurrentVersion = _ref.isCurrentVersion,
    isCurrentVersion = _ref$isCurrentVersion === void 0 ? false : _ref$isCurrentVersion,
    _ref$update = _ref.update,
    update = _ref$update === void 0 ? 'Update' : _ref$update,
    _ref$currentVersion = _ref.currentVersion,
    currentVersion = _ref$currentVersion === void 0 ? 'Current Version' : _ref$currentVersion,
    _ref$hideButton = _ref.hideButton,
    hideButton = _ref$hideButton === void 0 ? false : _ref$hideButton;
  var classes = (0, _FileDownloadItem.useStyles)();
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: classes.root,
    display: "flex",
    gridGap: "8px",
    flexDirection: "row",
    justifyContent: "space-between",
    minWidth: "160px"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    gridGap: "8px",
    flexDirection: "column",
    minWidth: "120px"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    flex: true,
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _proRegularSvgIcons.faFileAlt,
    className: classes.icon,
    height: "16px",
    width: "16px"
  }), isCurrentVersion ? /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.currentVersion
  }, currentVersion) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.update
  }, update, " | "), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.title
  }, title))), attributes === null || attributes === void 0 ? void 0 : attributes.map(function (attribute) {
    return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
      flex: true,
      marginLeft: "26px"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.subTitle
    }, attribute.key, ': '), /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.subContent
    }, attribute.value));
  })), !hideButton ? /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    height: "auto",
    alignItems: "center",
    display: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_button.IconButton, {
    icon: _proRegularSvgIcons.faDownload,
    color: isCurrentVersion ? 'primary' : 'default',
    onClick: onDownloadButtonClick
  })) : null);
};
exports.FileDownloadItem = FileDownloadItem;